<template>
  <v-container
    fluid
    class="py-0"
  >
    <top-bar
      header="Not Found"
    />
    <v-row>
      <v-col
        cols="12"
        md="9"
      >
        404, that's an error.
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <account-manager />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AccountInfo'
}
</script>
